// extracted by mini-css-extract-plugin
export default {"regularPopWrap":"RegularPopup_regularPopWrap__2gEOn","header":"RegularPopup_header__UU-Vw","closeBtn":"RegularPopup_closeBtn__Twnvt","content":"RegularPopup_content__xtX7T"};